const HUB_PLAY_URL = 'https://level.farm/api/stats/play';
const TIMEOUT_MS = 2500;

/** Ping fire-and-forget : une fois par partie, jamais bloquant. */
export function trackPlay(opts = {}) {
  try {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return;
    const gameSlug = String(opts.gameSlug || '').trim().toLowerCase();
    const gameKind = String(opts.gameKind || '').trim().toLowerCase();
    if (!gameSlug || (gameKind !== 'classic' && gameKind !== 'original')) return;
    const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), TIMEOUT_MS) : 0;
    const done = () => {
      if (timer) clearTimeout(timer);
    };
    fetch(HUB_PLAY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      keepalive: true,
      body: JSON.stringify({ gameSlug, gameKind }),
      signal: ctrl ? ctrl.signal : undefined,
    }).then(done, done);
  } catch {
    /* fire-and-forget */
  }
}

export function makePlayPing(gameSlug, gameKind = 'classic') {
  let sent = false;
  return {
    begin() {
      sent = false;
      this.note();
    },
    note() {
      if (sent) return;
      sent = true;
      trackPlay({ gameSlug, gameKind });
    },
  };
}
